var React = require('react');

function NavIconChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.953 17.244 14.242 14.24c.686.688 1.8.688 2.487 0l1.66-1.66a1.76 1.76 0 0 0 .004-2.484L17.059 16 28.346 4.66a1.76 1.76 0 0 0-.003-2.484L26.682.516a1.76 1.76 0 0 0-2.487 0L9.953 14.755a1.76 1.76 0 0 0 0 2.488"}));
}

NavIconChevronLeft.defaultProps = {"viewBox":"16 0 12 32","fill":"currentColor"};

module.exports = NavIconChevronLeft;

NavIconChevronLeft.default = NavIconChevronLeft;
